import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/kp_logo_4x.png'


const _withScopeId = n => (_pushScopeId("data-v-7f4ce826"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-main header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-center" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      width: "112"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "logo-dashboard font-headline-Regular mt-2" }, "Dashboard")
  ])
], -1))
const _hoisted_3 = { class: "space-wrapper" }
const _hoisted_4 = { class: "flex-center float-right" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-arrow-down el-icon--right" }, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Log Out")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.windowWidth > 420 && _ctx.userLogin)
          ? (_openBlock(), _createBlock(_component_el_dropdown, { key: 0 }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_dropdown_item, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logout()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  plain: "",
                  class: "py-0 btn-user"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.userLogin) + " ", 1),
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}